{
  "en": {
    "gallery": {
      "headers": {
        "subtitle": "What would you like to teach today?",
        "title": "Find ready-to-use teaching materials as OER"
      }
    }
  }
}
